"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchNavigate = exports.setProcess = void 0;

var _slice = require("./slice");

var setProcess = function setProcess() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch) {
    dispatch((0, _slice.setProcessAction)(state));
  };
};

exports.setProcess = setProcess;

var switchNavigate = function switchNavigate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch) {
    dispatch((0, _slice.switchNavigationAction)(state));
  };
};

exports.switchNavigate = switchNavigate;